import { VtToasterService } from '@services/vt-toaster.service';
import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {exhaustMap, retry, take} from 'rxjs/operators';
import {InformeRendimentosService} from '@services/informe-rendimentos.service';
import {interval, Subscription} from 'rxjs';
import {IButton} from '@interfaces/elements';
import { UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ModalLoadingComponent} from 'src/app/components/modal-loading/modal-loading.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FileDownloadService} from '@services/file-download.service';
import {FilenameParser} from '@utils/FilenameParser';
import { HttpResponse } from '@angular/common/http';
import {CnpjUtils} from '@utils/cnpj.utils';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { NgClass } from '@angular/common';
import { DataTableComponent } from '../../components/data-table/data-table.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-informe-rendimentos',
    templateUrl: './informe-rendimentos.component.html',
    styleUrls: ['./informe-rendimentos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatError, SelectOneComponent, NgClass, DataTableComponent, FooterComponent]
})
export class InformeRendimentosComponent implements OnInit {
  colunasMatriz: any = [
    {
      key: 'cnpj',
      title: 'ANO FISCAL MATRIZ',
      style: {'flex-grow': 0, 'justify-content': 'left', 'flex-shrink': 0, 'flex-basis': '200px'}
    },
    {
      key: 'arquivo',
      title: 'ARQUIVO',
      style: {'flex-grow': 1, 'justify-content': 'left'}
    }
  ];
  colunasFilial: any = [
    {
      key: 'cnpj',
      title: 'ANO FISCAL FILIAL',
      style: {'flex-grow': 0, 'justify-content': 'left', 'flex-shrink': 0, 'flex-basis': '160px'}
    },
    {
      key: 'razaoSocial',
      title: 'NOME DA FILIAL',
      style: {'flex-grow': 0, 'justify-content': 'left', 'flex-shrink': 0, 'flex-basis': '250px'}
    },
    {
      key: 'arquivo',
      title: 'ARQUIVO',
      style: {'flex-grow': 1, 'justify-content': 'left'}
    }
  ];
  toasterTimeout = 5_000;
  idEmpresaSelecionada: any;
  empresasPrincipais: any = [];
  empresasFiliais: any = [];
  anoSelecionado: any = (new Date()).getFullYear();
  loadingGenerico: any;
  paginacaoFilial = {
    page: 1,
    size: 5,
    total: 0
  };
  paginacaoMatriz = {
    page: 1,
    size: 5,
    total: 0
  };
  listaInformesSelecionados: any = [];
  idDownload: any;
  loadingGenericoMessage: string;
  subscriptions = new Subscription();
  loadingGenericoData = {
    buttons: [] as Array<IButton>,
  };
  empresasGrupo: any = [];
  dialogRef: MatDialogRef<ModalLoadingComponent>;
  formFiltro = this.formBuilder.group({
    ano: new UntypedFormControl(),
    empresa: new UntypedFormControl(),
  });
  baixouTodos: any = false;
  anoReferencia: any;
  descricaoPadrao: string = 'Todos';
  valorPadrao: number = 0;
  enterPesquisar: boolean = true;

  constructor(private readonly informeRendimentosService: InformeRendimentosService,
              private readonly formBuilder: UntypedFormBuilder,
              private readonly dialog: MatDialog,
              private readonly toaster: VtToasterService) {
  }

  ngOnInit(): void {
    this.idEmpresaSelecionada = localStorage.idEmpresaLogada;
    this.carregarFiltroAnoReferencia();
    this.getEmpresa();
  }

  public carregarFiltroAnoReferencia() {

    this.loadingGenerico = true;
    this.informeRendimentosService.getAnoReferencia().pipe(take(1))
    .subscribe({
      next: (retorno) => {
        this.anoReferencia = retorno.response.anoReferencia;
        this.loadingGenerico = false;
      },
      error: (erro: any) => {
        console.error(erro);
        this.loadingGenerico = false;
      }
    });
  }

  public getEmpresa(filtroEmpresa?: boolean) {
    this.loadingGenerico = true;
    this.anoSelecionado = this.formFiltro.value.ano ?? (new Date()).getFullYear();
    const textoArquivo = `Informe de Rendimentos - Exercício ${this.anoSelecionado} - ANO FISCAL COMPLETO`;
    this.empresasPrincipais = [];
    this.listaInformesSelecionados = [];
    this.idEmpresaSelecionada = this.idEmpresaSelecionada > 0 ? this.idEmpresaSelecionada : localStorage.idEmpresaLogada;
    this.informeRendimentosService.getEmpresa(this.idEmpresaSelecionada)
      .pipe(take(1))
      .subscribe({
        next: (page: any) => {
          const empresaPrincipal = page.response;
          if (!empresaPrincipal.matriz) {
            this.colunasMatriz[0].title = 'ANO FISCAL FILIAL';
          }
          this.empresasPrincipais.push(empresaPrincipal);
          if (this.empresasPrincipais.length > 0) {
            this.empresasPrincipais.forEach(e => {
              e.cnpj = CnpjUtils.format(e.cnpj);
              e.arquivo = textoArquivo;
            });
          }
          if (empresaPrincipal.filiais) {
            this.empresasFiliais = empresaPrincipal.filiais;
            this.paginacaoFilial.total = this.empresasFiliais.length;
            if (this.empresasFiliais.length > 0) {
              this.empresasFiliais.forEach(e => {
                e.cnpj = CnpjUtils.format(e.cnpj);
                e.arquivo = textoArquivo;
              });
            }
          } else {
            this.empresasFiliais = [];
          }
          if (!this.empresasGrupo.length) {
            this.empresasGrupo = this.empresasPrincipais.concat(this.empresasFiliais).map(empresa => {
              return {
                id: empresa.id,
                label: CnpjUtils.format(empresa.cnpj) + '  -  ' + empresa.razaoSocial,
                matriz: empresa.matriz,
              };
            });
          }
          if (filtroEmpresa) {
            if (this.empresasPrincipais.some(item => item.id === this.idEmpresaSelecionada && item.matriz)) {
              this.empresasFiliais = [];
              this.colunasMatriz[0].title = 'ANO FISCAL MATRIZ';
            }
          }
          this.loadingGenerico = false;
        },
        error: (erro: any) => {
          console.error(erro);
          this.loadingGenerico = false;
        }
      });
  }

  checkboxTableClickMatriz(informe: any) {
    informe.checked ? this.addEmpresaToList(informe) : this.removeEmpresaFromList(informe);
  }

  selecionaTodosFilial(input: any) {
    const checked = input?.target?.checked;
    this.empresasFiliais.forEach((empresa) => {
      checked ? this.addEmpresaToList(empresa, true) : this.removeEmpresaFromList(empresa);
    });
  }

  checkboxTableClickFilial(informe: any) {
    informe.checked ? this.addEmpresaToList(informe) : this.removeEmpresaFromList(informe);
  }

  addEmpresaToList(empresa: any, isCheckAll: boolean = false) {
    const index = this.listaInformesSelecionados.indexOf(empresa.id);
    if (index === -1) {
      this.listaInformesSelecionados.push(empresa.id);
    } else if (!isCheckAll) {
      this.listaInformesSelecionados.splice(index, 1);
    }
  }

  removeEmpresaFromList(empresa: any) {
    const index = this.listaInformesSelecionados.indexOf(empresa.id);
    if (index !== -1) {
      this.listaInformesSelecionados.splice(index, 1);
    }
  }


  iniciaCriacaoPdf(empresa: any) {

    this.toaster.success('Seu informe estará pronto em alguns segundos e será baixado automaticamente.', 'Informe solicitado com sucesso!', this.toasterTimeout);

    this.informeRendimentosService.getInformeUnico(empresa.id, this.anoSelecionado)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.idDownload = response.response.idDownload;

        if (response.response.urlDownload) {
          this.fecharLoading();

          const urlWithoutDomain: string = response.response.urlDownload.split('/').slice(3).join('/');
          const fileNameString: string = response.response.urlDownload.split('/').slice(5).toString();
          const finalName = fileNameString.indexOf('?');
          const fileName = fileNameString.substring(0, finalName);

          this.informeRendimentosService.dowloadInformePdf(urlWithoutDomain)
            .pipe(take(1))
            .subscribe({
              next: ({body, headers}: HttpResponse<any>) => {
                this.loadingGenerico = false;
                const filename = FilenameParser.fromContentDispositionHeader(
                  headers.get('content-disposition'),
                  fileName
                );
                FileDownloadService.download([body], filename);
              },
              error: (error) => {
                this.loadingGenerico = false;
                console.error(error);
              }
            });
        } else if (this.idDownload) {
          this.statusArquivo('pdf', empresa.id);
        }
      },
      error: (erro: any) => {
        this.openToastErro(erro);
      }
    });
  }

  private openLoadingErro(erro: any) {
    if (erro.status === 404 && erro.message) {
      this.openLoading('CNPJ sem informe para o ano solicitado:', 'Infelizmente não há informe disponível para o CNPJ no ano solicitado.',
        '', '633px', false, true, 'Entendi'
      );
    } else {
      this.openLoading('Ops, algo deu errado :(', 'Não conseguimos baixar o informe solicitado, tente novamente.',
        '', '533px', false, true, 'Tentar Novamente'
      );
    }
  }

  private openToastErro(erro: any) {
    if (erro.status === 404 && erro.message) {
      this.toaster.error('Infelizmente não há informe disponível para o CNPJ no ano solicitado.', 'CNPJ sem informe para o ano solicitado:', this.toasterTimeout

      );
    } else {

      this.toaster.error('Não conseguimos baixar o informe solicitado, tente novamente.', 'Ops, algo deu errado :(', this.toasterTimeout

      );
    }
  }

  iniciaCriacaoZip() {
    if (this.isBaixarTodos()) {
      this.checkAll();
    }
    this.baixouTodos = true;

    this.openLoading('Informe solicitado com sucesso!', 'Seu informe estará pronto em alguns <b>minutos.</b>',
      '<b>Aguarde seu arquivo</b> ser baixado automaticamente.', '633px', true, false, ''
    );
    this.informeRendimentosService.getInformeMassa(this.listaInformesSelecionados, this.anoSelecionado)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.idDownload = response.response.idDownload;
        this.statusArquivo('zip', this.listaInformesSelecionados[0]);
      },
      error: (erro: any) => {
        this.openLoadingErro(erro);
      }
    });
  }

  checkAll() {
    const checkboxes = document.querySelectorAll('input[type=checkbox]');
    checkboxes.forEach((checkbox: any) => {
      checkbox.checked = true;
    });
    this.selecionaTodosFilial(true);
  }

  private statusArquivo(tipoArquivo: string, empresaId: number) {
    const subscription = interval(10000)
      .pipe(
        exhaustMap(() => this.informeRendimentosService.getFileGenerationStatus(this.idDownload, tipoArquivo, empresaId)
          .pipe(retry(10)),
        ),
      )
      .subscribe({
        next: ({response}: any) => {
          if (response?.status === 'FINALIZADO') {
            window.open(response?.urlDownload);
            subscription.unsubscribe();
            this.fecharLoading();
            this.baixouTodos = false;
          } else if (response?.status === 'SEM ARQUIVO' && tipoArquivo === 'zip') {
            subscription.unsubscribe();
            this.baixouTodos = false;
            this.openLoading(
              'CNPJ sem informe para o ano solicitado:',
              'Infelizmente não há informe disponível para o CNPJ no ano solicitado.',
              '', '633px', false, true, 'Entendi'
            );
          } else if (response?.status !== 'EM_ANDAMENTO') {
            this.toaster.error(
              'Infelizmente não há informe disponível para o CNPJ no ano solicitado.',
              'CNPJ sem informe para o ano solicitado:',
              this.toasterTimeout
            );
            this.baixouTodos = false;
          }
        },
        error: (error) => {
          if (tipoArquivo === 'zip') {
            this.openLoading(
              'Ops, algo deu errado :(',
              'Não conseguimos baixar o informe solicitado, tente novamente.',
              '', '533px', false, true, 'Tentar Novamente'
            );
          } else {
            this.toaster.error(
              'Não conseguimos baixar o informe solicitado, tente novamente.',
              'Ops, algo deu errado :(',
              this.toasterTimeout
            );
          }
        }
      });
    this.subscriptions.add(subscription);
  }


  verificaAnoPreenchido() {
    this.formFiltro.get('ano').updateValueAndValidity();
    if (this.formFiltro.get('ano')?.value && this.formFiltro.get('ano')?.value.length < 3) {
      this.formFiltro.get('ano').setErrors({invalid: true, message: 'Favor preencher um ano válido.'});
    } else if (new Date().getFullYear() < this.formFiltro.get('ano')?.value) {
      this.formFiltro.get('ano').setErrors({invalid: true, message: 'Busque até o ano vigente.'});
    } else if (this.formFiltro.get('ano')?.value <= this.anoReferencia) {
      this.formFiltro.get('ano').setErrors({
        invalid: true,
        message: 'Inclua dados dos últimos 11 anos. Por favor, ajuste o ano.'
      });
    }
    this.anoSelecionado = this.formFiltro.get('ano').value;
  }

  limparFiltro() {
    this.formFiltro.reset();
    this.anoSelecionado = (new Date()).getFullYear();
    this.idEmpresaSelecionada = localStorage.idEmpresaLogada;
    this.getEmpresa();
  }

  openLoading(title: string, text1: string, text2: string, width: string, disableClose: boolean, erroLoading: boolean, textButton: string
  ) {
    this.fecharLoading();

    this.dialogRef = this.dialog.open(ModalLoadingComponent, {
      disableClose,
      hasBackdrop: true,
      data: {erroLoading, title, text1, text2, textButton},
      width
    });
  }

  onChangeEmpresa(event: any) {
    this.idEmpresaSelecionada = event;
    this.formFiltro.value.empresa = event;

    let filtro = false;

    if (this.idEmpresaSelecionada > 0) { filtro = true; }
    this.getEmpresa(filtro);
  }

  isBaixarTodos() {
    return this.listaInformesSelecionados.length === 0;
  }

  fecharLoading() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  campoFiltroPreenchido() {
    return this.formFiltro.value.ano ?? this.formFiltro.value.empresa;
  }

  buscaInativa() {
    return !this.campoFiltroPreenchido() ||
      this.formFiltro.get('ano')?.invalid ||
      this.formFiltro.get('ano')?.value?.length <= 3;
  }

  allCheckBoxesClicked() {
    return this.listaInformesSelecionados.length === this.empresasFiliais.length + this.empresasPrincipais.length;
  }

  buscar() {
    this.idEmpresaSelecionada = localStorage.idEmpresaLogada;
    this.formFiltro.get('empresa').setValue('');
    this.getEmpresa();
  }
}

